export const defaultTemplates = {
  c: `#include <stdio.h>

int main() {
  // your code goes here
  return 0;
}`,

  cpp: `#include <iostream>
using namespace std;

int main() {
  // your code goes here
  return 0;
}`,

  java: `public class Main {
  public static void main(String[] args) {
    // your code goes here
  }
}`,

  python: `# your code goes here
print("Hello World")`,

  scala: `object Main {
  def main(args: Array[String]): Unit = {
    // your code goes here
    println("Hello, Scala!")
  }
}`,

  sql: `SELECT * FROM table_name WHERE condition;`,

  react: 
  
 `import React from 'react';

  function App() {
  return null;
  } 

  export default App;`,


  angular: 
  
`import { Component } from '@angular/core';

@Component({
  selector: 'app-root',

  template: ''
})
export class AppComponent {}
`,
};
